// extracted by mini-css-extract-plugin
export default {"build":"AdminLinks-module--build--775ab"};